// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1GC5z","info":"PatientInfo_info__16oPu"};